export const createArray = (iterable) => iterable ? Array.from(iterable) : [];
export const isArray = (arg) => Array.isArray(arg);
export const pushToArray = (array, ...items) => array.push(...items);
export const joinArray = (array, separator) => array.join(separator);
export const clearArray = (array) => void (array.length = 0);
export const sizeOfArray = (array) => array.length;
export const sliceOfArray = (array, start, end) => array.slice(start, end);
export const forEachOfArray = (array, callbackFn, thisArg) => array.forEach(callbackFn, thisArg);
export const shiftArray = (array) => array.shift();
export const popArray = (array) => array.pop();
export const unshiftArray = (array, ...items) => array.unshift(...items);
export const spliceArray = (array, start, deleteCount) => array.splice(start, deleteCount);
export const cloneArray = (array) => array.slice(0);
